import { parseISOLocal } from './date';
import { isAfter } from 'date-fns';
import getMinDate from './getMinDate';

function getMaxDate(config) {
  let maxDate =
    config.maxDate == null || config.maxDate.trim() == ''
      ? null
      : parseISOLocal(config.maxDate);
  const minDate = getMinDate(config);
  if (maxDate != null && minDate != null && isAfter(minDate, maxDate)) {
    maxDate = minDate;
  }
  return maxDate;
}

export default getMaxDate;
